<template lang="pug">
  .card.column(:class="{alert: item.valore < item.soglia, 'is-half': display === 'grid',  'is-12': display === 'list'}")
    div.actions.is-pulled-right
      span.is-info
        a(:href="`./static/pdf/${item.idweb}.pdf`" target="new")
          icon-base(width="14" height="14" icon-name="SCHEDA INDICATORE" iconColor="#ffffff")
            icon-info
      span.is-view(@click="toggleMap(item)" v-if="item.webgisLayer")
        div(v-if="item.hidden")
          icon-base(width="16" height="16" icon-name="Mostra layer" iconColor="#0567b3")
            icon-eye
        div(v-else)
          icon-base(width="16" height="16" icon-name="Nascondi layer" iconColor="#0567b3")
            icon-eye-disabled
    .label.tooltip.is-tooltip-right(v-if="item.obiettivo" :data-tooltip="item.obiettivo") {{ item.idweb }}
    .label(v-else) {{ item.idweb }}
    .text {{ item.indicatore }}
    .bar
      .value(:style="{ width: percentage(item.valore) }")
    table(style='spacing: 0px; border:1px')
      tr
        td(style='text-align: left') 0
        td(style='text-align: right') 1
    br
</template>
<script>
import IconBase from '@/components/IconBase'
import IconInfo from '@/components/icons/IconInfo'
import IconEye from '@/components/icons/IconEye'
import IconEyeDisabled from '@/components/icons/IconEyeDisabled'
import { loadModules } from 'esri-loader'
export default {
  name: 'IndicatorItem',
  components: {
    IconBase,
    IconInfo,
    IconEye,
    IconEyeDisabled
  },
  props: {
    item: Object,
    index: Number,
    display: String
  },
  computed: {
    selectedActions () {
      return this.$store.getters.selectedActions(this.action)
    },
    webCartLayer () {
      return this.$store.state.webCartLayer
    }
  },
  methods: {
    percentage (value) {
      return (value * 100).toFixed(1) + '%'
    },
    toggleMap (layer) {
      // this.$store.commit('SET_TOGGLE_CHARACTERIZATION', layer)
      // let mapLayer = this.webCartLayer.allSublayers.find(sublayer => sublayer.title === layer.layer.webgisLayer)

      loadModules(
        [
          'esri/layers/FeatureLayer'
        ],
        { url: this.$store.state.config.arcgis }
      ).then(
        ([
          FeatureLayer
        ]) => {
          let _this = this
          let mapLayer = _this.webCartLayer.allSublayers.items.find(sublayer => sublayer.title.toUpperCase() === layer.webgisLayer.toUpperCase())

          let layerx = new FeatureLayer({
            url: _this.$store.state.config.MapServer.url + mapLayer.id
          })

          if (typeof _this.$store.state.map.layers.items.find((item) => item.layerId === mapLayer.id) === 'undefined') {
            _this.$store.state.map.add(layerx)
            layer.hidden = !layer.hidden
          } else {
            _this.$store.state.map.layers.items.find((x) => x.layerId === layerx.layerId).visible = !_this.$store.state.map.layers.items.find((x) => x.layerId === layerx.layerId).visible
            layer.hidden = !layer.hidden
          }
        })
      // let mapLayer = this.webCartLayer.allSublayers.items.find(sublayer => sublayer.title === layer.webgisLayer)
      // mapLayer.visible = !mapLayer.visible
      // layer.hidden = !layer.hidden
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
    height: 16em;
    font-size: .8em;
    padding-top: 2em;
    padding-right: 4em;
    &.alert {
      .value {
        background-color: #d7716c;
      }
      .label {
         background-color: #d7716c;
      }
    }
  }
  .text {
    min-height: 8em;
  }

  .label {
    background-color: #77bd8b;
    display: inline-block;
    color: #fff;
    padding: .2rem .4rem;
    font-size: 1em;
    text-transform: uppercase;
  }
  .bar {
    display: inline-block;
    margin-top:15px;
    border-radius: 1px;
    height: 15px;
    width: 100%;
    background-color: #e6e6e6;
    position: relative;
  }
  .value {
    height: 15px;
    display: inline-block;
    background-color: #77bd8b;

  }
  .text {
    padding: 2em 0;
    font-weight: bold;
  }
  .threshold {
    border-right: 2px solid #fff;
    height: 15px;
    display: inline-block;
    position: absolute;
    left: 0;
  }
  .actions {
    span {
      cursor: pointer;
      display: inline-block;
      margin: .5em;
    }
  }
  .is-info {
    background-color: #4d6b82;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndicatorsItem.vue